var React = require('react');

function Brush (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#BrushThemeIcon__clip0)","key":0},React.createElement("path",{"d":"M23.152 0C22.218.054 8.422 11.83 7.29 15.977l2.614 2.739C17.378 12.484 19.778 5.884 24 .013L23.152 0zM6.465 16.811C1.742 18.548 4.703 21.985 0 23.667c5.326 1.2 7.686-.995 9.08-4.108L6.465 16.81z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"BrushThemeIcon__clip0"},React.createElement("path",{"d":"M0 0h24v24H0z"})))]);
}

Brush.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Brush;

Brush.default = Brush;
